// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".business-logo{background-color:#fff;border-radius:25%;box-sizing:border-box;overflow:hidden;position:relative}.business-logo.rounded,.business-logo.rounded .v-image__image{border-radius:50%!important}.business-logo .v-image__image{border-radius:25%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
